import { Link } from 'react-router-dom';
const Footer = () => {
  const yr = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          <div className="copyright">
            © Dev5.dev {yr} | All Rights Reserved.
          </div>
          <div className='footer-menu'>
          <Link to="/">Home</Link> | <Link to="/about">About Us</Link> | <Link to="/contact">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;